import DatabasesBox from "../components/databases-box";
import UsersBox from "../components/users-box";

<template>
  <div class="grid gap-8 mt-8">
    <DatabasesBox @database={{@model.database}} />
    <UsersBox @database={{@model.database}} />
  </div>
</template>
